import { get } from "../utility/fetch-util";

// Get X2O web.xml deployment parameter value
export const getDeploymentParamValue = async (webParamName) => {
    return get('/api/platform/config/deploymentParam/' + webParamName, null, null);
}

// Get definable content
export const getDefinableContent = async (contentCode) => {
    return get('/api/platform/config/defContent/' + contentCode, null, null);
}

// Get default entity reg address
export const getEntityRegisteredAddressObject = async (progress) => {
    return get('/api/core/company/regAddress', null, progress);
}

// Get default entity company reg no
export const getEntityRegisteredNumber = async () => {
    return get('/api/core/company/regNumber', null, null);
}

// Get translation language options
export const getTranslationLocales = async () => {
    return get('/api/users/configuration/locales/translation', null, null);
}

// Get available security questions
export const getSecurityQuestions = async () => {
    return get('/api/platform/config/securityQuestions', null, null);
}